<div class="progress-spinner w-100 h-100 z-index-10 absolute top-0">
  <ps-spinner color="purple" size="100px" thickness="8px"></ps-spinner>
</div>
